<script>
import appConfig from '@src/app.config.json'
import Axios from 'axios'
import Layout from '@layouts/main.vue'

export default {
  page: {
    title: 'Term Of Use',
    meta: [{ name: 'description', content: 'The Term Of Use page.' }],
  },
  components: { Layout },
  data() {
    return {
      tou: {},
      isLoading: true,
      /** language switcher global */
      lang: localStorage.getItem('lang') ? localStorage.getItem('lang') : 'id',
    }
  },
  mounted() {
    this.getTou()
  },
  methods: {
    getTou: function() {
      /** define ANY API prequisite */
      var params = {
        klaster_slug: 'term-of-use',
        simple: true,
        lang: this.lang,
        taxonomy_show: false,
        attribute_show: false,
      }
      /** params need to encoded from object to url params */
      params = Object.keys(params)
        .map(function(key) {
          return key + '=' + params[key]
        })
        .join('&')
      /** token required for getting data from backend  */
      const getOptions = {
        headers: {
          Authorization: appConfig.default_token,
          'Access-Control-Allow-Origin': '*',
        },
      }
      /** define endpoint */
      var endpoint = `${appConfig.endpoint}/klaster-by-member-relation?${params}`
      // get the news
      Axios.get(endpoint, getOptions).then((response) => {
        const data = response.data.data
        console.log(response.data)
        if (response.data) {
          this.tou = data
          this.isLoading = false
        }
      })
    },
  },
}
</script>

<template>
  <Layout>
    <b-container class="my-5">
      <div
        v-show="isLoading"
        class="col-12 position-relative"
        style="min-height: 50vh"
      >
        <img
          src="@assets/icons/loading.gif"
          alt="loading"
          class="loadingIcon"
        />
      </div>
      <b-row class="justify-content-center">
        <b-col cols="lg-12" class="mb-5">
          <div v-for="(item, index) in tou" :key="index" :ref="item.slug">
            <div v-if="index === 0" class="text-center">
              <h1
                :style="{
                  color: 'var(--primary)',
                  fontWeight: 700,
                  textAlign: 'center',
                }"
              >
                {{ item.title }}
              </h1>
              <div v-html-safe="item.content"></div>
            </div>
          </div>
        </b-col>
        <b-col cols="lg-12" class="mt-4">
          <div class="touContent">
            <section v-for="(item, index) in tou" :key="index" :ref="item.slug">
              <div v-if="index > 0">
                <h2 class="text-dark mb-3" bold>{{ item.title }}</h2>
                <div v-html-safe="item.content"></div>
                <div
                  v-if="tou[tou.length - 1].slug !== item.slug"
                  style="margin: 3rem auto"
                ></div>
              </div>
            </section>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </Layout>
</template>
